import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { AdminReviewListing, AllReviewList, ReviewListing } from 'src/app/models/review';
import { ReviewManagementService } from 'src/app/services/review-management.service';
import { DeleteReviewsComponent } from '../delete-reviews/delete-reviews.component';

@Component({
  selector: 'app-reviews-product-list',
  templateUrl: './reviews-product-list.component.html',
  styleUrls: ['./reviews-product-list.component.css']
})
export class ReviewsProductListComponent implements OnInit {

  reviewListModel: AdminReviewListing = new AdminReviewListing();
  reviewsListing: AllReviewList = new AllReviewList();
  totalPages: number;
  pageNumber: number = 1;
  pagingModel: PagingModel;
  searchValue: string = "";
  Loader: boolean = false;

  constructor(private _reviewListService: ReviewManagementService, private modalService: NgbModal, private router: Router) { 
    this.pagingModel = new PagingModel();
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
  }

  ngOnInit() {
    this.productReviews();
  }

  productReviews() {
    this.Loader = true;
    this._reviewListService.adminReviewList(this.reviewListModel)
      .subscribe((response) => {
        this.Loader = false;
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.reviewsListing.ProductSort = responseBody.responseData;
          this.reviewsListing.TotalPages = responseBody.totalPages;
          this.totalPages = this.reviewsListing.TotalPages == undefined ? 0 : this.reviewsListing.TotalPages
        } (err) => {
        }
      });
  }

  goToReviewsEdit(reviewDetail) {
    this.router.navigate(['/update-review/' + reviewDetail.id]);
  }

  deleteReview(reviewDelete) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(DeleteReviewsComponent, modalConfig);
    modalRef.componentInstance.ReviewId = reviewDelete.id;
    modalRef.result.then(() => {
    }, (reason) => {
      this.productReviews();
    })
  }

  resetFilter() {
    this.reviewListModel.PageNumber = 1;
    this.reviewListModel.PageSize = 10;
    this.totalPages = 1;
    this.pageNumber = 1;
    this.searchValue = "";
    this.reviewListModel.KeyWord = this.searchValue;
    this.productReviews();
  }

  filter() {
    this.reviewListModel.KeyWord = this.searchValue;
    this.reviewListModel.PageNumber = 1;
    this.reviewListModel.PageSize = 10;
    this.productReviews();
  }

  loadPage(pagingModel: PagingModel) {
    this.reviewListModel.PageNumber = pagingModel.pageNumber;
    this.reviewListModel.PageSize = pagingModel.pageSize;
    this.productReviews();
  }
}
